import { getRouteApi, useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { CatalogAdminEditionClientProvider } from '@/api/catalog-client-context';
import { HttpCatalogAdminEditionClient } from '@/api/catalog-edition-client.http';
import { OperationalViewProfilsScreen } from '@/routes/admin/operational-view/operational-view-profils-screen';

// =============================================================================
// operational-view-profils-route.tsx — Adaptateur routeur de la Page Profils (§2.5 v2.2 / C1).
// =============================================================================
// L'id de campagne est le path param d'URL (« /admin/campaigns/$campaignId/operational-view/profils »)
// — ressource d'URL, cohérent avec le contrat API (campaignId server-set, invariant n°1). Le composant
// de présentation reste testable hors routeur.
//
// FILTRE Famille (N1) / Sous-famille (N2) : la page joint FRONT-SIDE le catalogue figé de la campagne via
// `useCatalogProfiles`, qui lit le contexte CatalogAdminEditionClient — dont le DÉFAUT global est un STUB
// (catalogue auto-porté, S8/S9 stub-first). On enveloppe donc CETTE route avec le client HTTP RÉEL
// (lecture seule) : sans lui, la jointure famille lit le stub ⇒ filtre jamais rendu pour une campagne
// réelle (divergence ST-CAMPAIGN-02 T2). Singleton module : une instance partagée par la route.

/** Client HTTP réel (lecture) du catalogue — injecté pour la jointure Famille/Sous-famille de la page. */
const catalogEditionClient = new HttpCatalogAdminEditionClient();

const routeApi = getRouteApi(
  '/admin/campaigns/$campaignId/operational-view/profils',
);

export function OperationalViewProfilsRoute(): React.JSX.Element {
  const { campaignId } = routeApi.useParams();
  const navigate = useNavigate();

  const onViewFournisseurs = React.useCallback((): void => {
    void navigate({
      to: '/admin/campaigns/$campaignId/operational-view/fournisseurs',
      params: { campaignId },
    });
  }, [navigate, campaignId]);

  return (
    <CatalogAdminEditionClientProvider client={catalogEditionClient}>
      <OperationalViewProfilsScreen
        campaignId={campaignId}
        onViewFournisseurs={onViewFournisseurs}
      />
    </CatalogAdminEditionClientProvider>
  );
}
